"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    sendEmailVerificationCode: ()=>sendEmailVerificationCode,
    verifyEmailCode: ()=>verifyEmailCode,
    useSendEmailVerificationCode: ()=>useSendEmailVerificationCode,
    useVerifyEmailCode: ()=>useVerifyEmailCode
});
const _reactQuery = require("react-query");
const _ = require("../..");
const sendEmailVerificationCode = (payload, opts)=>{
    return _.api.post('/native_app/v1/consumer/send_code_email', payload, opts);
};
const verifyEmailCode = (payload, opts)=>{
    return _.api.post('/native_app/v1/consumer/validate_email', payload, opts);
};
const useSendEmailVerificationCode = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>{
        return sendEmailVerificationCode({
            email: payload.email,
            member_id: payload.member_id
        });
    }, queryOptions);
};
const useVerifyEmailCode = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>{
        return verifyEmailCode({
            email: payload.email,
            code: payload.code,
            member_id: payload.member_id
        });
    }, queryOptions);
};
